/**
 * preview.js - Interactive behaviors for Underlinen Kalles Preview
 * Implements section 6.8 behaviors with zero console errors.
 */

(function () {
  'use strict';

  // --- 1. Toast Notifications ---
  function getToastContainer() {
    let container = document.getElementById('so-toast-container');
    if (!container) {
      container = document.createElement('div');
      container.id = 'so-toast-container';
      container.className = 'so-toast-container';
      document.body.appendChild(container);
    }
    return container;
  }

  function showToast(msg) {
    const container = getToastContainer();
    const toast = document.createElement('div');
    toast.className = 'so-toast';
    toast.textContent = msg;
    container.appendChild(toast);
    setTimeout(() => toast.classList.add('so-visible'), 10);
    setTimeout(() => {
      toast.classList.remove('so-visible');
      setTimeout(() => toast.remove(), 300);
    }, 3200);
  }

// --- 2. Cart Management (Shopify AJAX Cart API) ---
  const SO_PRODUCT_CACHE = {};
  let _soCart = null;

  function soMoney(cents) {
    return '₹ ' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function normOpt(s) {
    return (s || '').toString().toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  async function soFetchCart() {
    const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    if (!r.ok) throw new Error('cart fetch failed');
    _soCart = await r.json();
    return _soCart;
  }

  // Legacy shape for any older callers; backed by the real Shopify cart.
  function getCart() {
    if (!_soCart) return [];
    return _soCart.items.map((it) => ({
      key: it.key,
      handle: it.handle || it.product_handle || '',
      title: it.product_title,
      price: soMoney(it.final_price != null ? it.final_price : it.price),
      color: '', size: it.variant_title || '',
      image: it.image || '',
      qty: it.quantity
    }));
  }

  function saveCart() { updateCartUI(); }

  const SO_PRODUCT_INFLIGHT = {};
  async function soGetProduct(handle) {
    if (SO_PRODUCT_CACHE[handle]) return SO_PRODUCT_CACHE[handle];
    if (SO_PRODUCT_INFLIGHT[handle]) return SO_PRODUCT_INFLIGHT[handle];
    SO_PRODUCT_INFLIGHT[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } })
      .then((r) => { if (!r.ok) throw new Error('product not found: ' + handle); return r.json(); })
      .then((p) => { SO_PRODUCT_CACHE[handle] = p; return p; })
      .finally(() => { delete SO_PRODUCT_INFLIGHT[handle]; });
    return SO_PRODUCT_INFLIGHT[handle];
  }
  // warm the product JSON before the shopper taps add (PDP on load, cards on first touch/hover of their button)
  function soPrefetch(handle) { if (handle) soGetProduct(handle).catch(() => {}); }

  function soFindVariant(product, item) {
    const variants = product.variants || [];
    if (!variants.length) return null;
    const names = (product.options || []).map((o) => (o.name || '').toLowerCase());
    const wantSize = normOpt(item.size);
    const wantColor = normOpt(item.color);
    const freeSize = ['free size', 'one size', 'pick your size', 'fs', ''].indexOf(wantSize) !== -1;
    const noColor = wantColor === '';
    // Exact option match first. The loose match below treats "xl" as containing "l", so XL/XXL
    // landed on L (Amit, 18 Oct). Only fall back to it when nothing matches exactly.
    const isSize = (n) => n.indexOf('size') !== -1 || n === 'title';
    const isColor = (n) => n.indexOf('color') !== -1 || n.indexOf('colour') !== -1;
    const exactHits = variants.filter((v) => names.every((n, i) => {
      const val = normOpt(v['option' + (i + 1)]);
      if (isSize(n)) return freeSize || val === wantSize;
      if (isColor(n)) return noColor || val === wantColor;
      return true;
    }));
    if (exactHits.length && !(freeSize && noColor)) return exactHits.find((v) => v.available) || exactHits[0];
    let best = null, bestScore = -1;
    for (const v of variants) {
      let score = 0, checked = 0, exact = true;
      for (let i = 0; i < names.length; i++) {
        const val = normOpt(v['option' + (i + 1)]);
        if (val === '') continue;
        checked++;
        let matched = false;
        if (names[i].indexOf('size') !== -1 || names[i] === 'title') {
          matched = !freeSize && (val === wantSize || val.indexOf(wantSize) !== -1 || wantSize.indexOf(val) !== -1);
        } else if (names[i].indexOf('color') !== -1 || names[i].indexOf('colour') !== -1) {
          matched = !noColor && (val === wantColor || val.indexOf(wantColor) !== -1 || wantColor.indexOf(val) !== -1);
        }
        if (matched) score += 2; else if (names[i].indexOf('size') !== -1 || names[i].indexOf('color') !== -1 || names[i].indexOf('colour') !== -1) exact = false;
      }
      if (exact && checked > 0 && v.available) return v;         // exact, available
      const total = score + (v.available ? 0.5 : 0);
      if (total > bestScore) { bestScore = total; best = v; }
    }
    if (best && best.available) return best;
    return variants.find((v) => v.available) || null;
  }

  // Bag confirmation strip at the top of the drawer: 'adding' (instant, on click) -> 'added' / 'error'.
  function soAddedStrip(state, item, msg) {
    const drawer = document.getElementById('t4s-mini_cart');
    if (!drawer) return;
    soBagShell(drawer);
    let el = drawer.querySelector('.so-bag-added');
    if (!el) {
      el = document.createElement('div');
      el.className = 'so-bag-added';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      drawer.querySelector('.so-bag-head').insertAdjacentElement('afterend', el);
    }
    const what = item ? soEsc(item.title) + (item.size && !/^(free size|one size|pick your size)$/i.test(item.size) ? ' · ' + soEsc(item.size) : '') : '';
    el.className = 'so-bag-added is-' + state;
    el.innerHTML = state === 'error'
      ? `<span class="so-bag-added-ic">!</span><span>${soEsc(msg || 'Could not add to your bag. Please try again.')}</span>`
      : `<span class="so-bag-added-ic">${state === 'adding' ? '' : '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>'}</span><span><b>${state === 'adding' ? 'Adding to your bag' : 'Added to your bag'}</b>${what ? '<small>' + what + '</small>' : ''}</span>`;
  }
  // placeholder line at the top of the bag until /cart.js comes back (renderBag replaces the list)
  function soPendingRow(item) {
    const list = document.querySelector('#t4s-mini_cart .so-cart-items-list');
    if (!list || !item) return;
    const empty = list.querySelector('.so-bag-empty');
    if (empty) empty.remove();
    const img = item.image ? String(item.image).split('?')[0] + '?width=180' : '';
    const row = document.createElement('div');
    row.className = 'so-bag-item so-bag-pending';
    row.innerHTML = `<span class="so-bag-img">${img ? `<img src="${soEsc(img)}" alt="">` : ''}</span>
      <div class="so-bag-info"><span class="so-bag-title">${soEsc(item.title)}</span>
      ${item.size && !/^(free size|one size|pick your size)$/i.test(item.size) ? `<div class="so-bag-var">${soEsc(item.color ? item.color + ' / ' + item.size : item.size)}</div>` : ''}
      <div class="so-bag-price"><b>${soEsc(item.price || '')}</b></div></div>`;
    list.insertBefore(row, list.firstChild);
  }
  function soBumpCount(n) {
    document.querySelectorAll('[data-cart-count], .t4s-cart-count').forEach((el) => {
      const v = (parseInt(el.textContent, 10) || 0) + n;
      el.textContent = v;
      el.classList.toggle('t4s-op-0', v === 0);
    });
  }

  async function addToCart(item, opts) {
    opts = opts || {};
    const quiet = opts.silent || opts.thenCheckout;
    if (!quiet) { soAddedStrip('adding', item); soPendingRow(item); openDrawer('#t4s-mini_cart'); }
    const fail = (msg) => { if (quiet) showToast(msg); else soAddedStrip('error', item, msg); };
    try {
      const product = await soGetProduct(item.handle);
      const variant = soFindVariant(product, item);
      if (!variant) { fail('This product is unavailable.'); return; }
      if (!variant.available) { fail('Sorry, that option is sold out.'); return; }
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: item.qty || 1 })
      });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        fail((err.description || 'Could not add to cart.').replace(/<[^>]*>/g, ''));
        updateCartUI();
        return;
      }
      if (opts.thenCheckout) { window.location.href = '/checkout'; return; }
      soBumpCount(item.qty || 1);                 // badge moves the moment Shopify confirms
      if (!quiet) soAddedStrip('added', Object.assign({}, item, { size: variant.public_title || item.size }));
      await updateCartUI();                       // one /cart.js fetch, then the lines render
    } catch (e) {
      console.error('addToCart failed', e);
      fail('Could not add to cart. Please try again.');
    }
  }

  // Cart drawer ("bag"). Offer bar = Amit's slab (₹2,999 → 20% … ₹9,999 → 50%) on the bag-offer styles,
  // mirroring the Shopify automatic discounts (product level, so every size of those styles counts).
  // onlyTag limits it to logged-in customers with that tag; null = everyone.
  const SO_OFFER = Object.assign({ enabled: true, onlyTag: null, excludedVariants: [46778402668795, 46778402701563, 46779779186939], tiers: [[299900, 20], [499900, 25], [699900, 30], [999900, 50]], eligibleHandles: ["fc-moisture-wicking-antimicrobial-cotton-modal-oxford-mens-long-trunk-pack-of-2", "fc-moisture-wicking-antimicrobial-cotton-modal-baron-mens-long-trunk-pack-of-2", "fcuk-moisture-wicking-antimicrobial-cotton-baton-mens-vests-pack-of-3", "fcuk-play-leyton-mens-boxers", "puma-woven-boxer-side-pocket-685245", "puma-woven-boxer-side-pocket-685244", "puma-woven-boxer-inner-elastic-685257", "puma-woven-boxer-side-pocket-685254", "puma-woven-boxer-side-pocket-685253", "puma-woven-boxerside-pocket-685252", "puma-woven-boxerside-pocket-685251", "puma-woven-boxer-side-pocket-685250", "puma-woven-boxer-side-pocket-685249", "puma-woven-boxer-side-pocket-685248", "puma-woven-boxer-side-pocket-685247", "puma-woven-boxer-side-pocket-685246", "puma-woven-boxer-side-pocket-685243", "puma-woven-boxer-side-pocket-685242", "puma-woven-boxer-side-pocket-685241", "puma-woven-boxers-side-pocket-678651", "fcuk-moisture-wicking-cotton-poly-viscose-heat-retention-bradfordmens-thermals-t-shirts", "fcuk-moisture-wicking-heat-retention-bradford-lj-mens-thermals-long-john", "fcuk-moisture-wicking-antimicrobial-cotton-rove-mens-vests-pack-of-2", "puma-basic-sleeveless-mens-vests-pack-of-2-with-everfresh-technology-1", "puma-basic-sleeveless-mens-vests-pack-of-2-with-everfresh-technology", "puma-mens-sleeveless-vests-pack-of-2-with-everfresh-technology", "puma-mens-crew-neck-vests-pack-of-2-with-everfresh-technology", "puma-mens-basic-cotton-woven-boxers-pack-of-1", "puma-mens-basic-woven-boxers", "sport-quarter-socks-pack-of-1", "sport-quarter-socks-pack-of-2", "french-connection-siene-mens-lounge-pants", "french-connection-leers-mens-crew-neck-sweatshirt", "french-connection-charron-mens-jog-pants", "french-connection-rhone-mens-high-neck-sweatshirt", "french-connection-durance-mens-hooded-sweatshirt", "fcuk-flex-berskhire-mens-oversized-hooded-sweatshirt", "sport-quarter-socks-pack-of-3", "unisex-quarter-socks-pack-of-1", "heritage-striped-unisex-short-crew-socks-pack-of-3", "puma-supima-mens-trunks-team-royal", "puma-supima-mens-trunks-asphalt", "puma-supima-mens-trunks-dark-olive", "puma-bamboo-mens-trunks-black-white", "puma-supima-mens-trunks-black", "puma-bamboo-mens-printed-trunk-gray-violet-white-black", "puma-bamboo-mens-trunks-deep-teal-black", "puma-bamboo-mens-trunks-vineyard-wine-black", "puma-bamboo-mens-printed-trunk-team-royal-vibrant-oragne-white", "puma-bamboo-mens-trunks-warm-chestnut-white", "puma-mens-lounge-pants-black", "puma-mens-printed-lounge-pants-black-white", "puma-mens-lounge-pants-navy", "puma-mens-printed-lounge-pants-black-mint-white", "puma-mens-lounge-pants-olive", "puma-mens-printed-lounge-pants-black-red", "puma-mens-lounge-pants-warm-chestnut-black", "fcuk-flex-holborn-mens-shorts", "fcuk-play-leyton-mens-printed-boxer", "puma-thermoshield-mens-thermal-pants-68841101", "puma-thermoshield-mens-thermal-pants-68841102", "womens-thermal-pants-68841301", "womens-thermal-pants-68841302", "womens-thermal-pants-68841303", "puma-thermoshield-mens-long-sleeve-thermal-top-68802401", "puma-thermoshield-mens-long-sleeve-thermal-top-68802402", "puma-womens-long-sleeve-thermal-top-68841202", "puma-womens-long-sleeve-thermal-top-68841203", "french-connection-lyon-mens-loungepants-pack-of-1", "french-connection-charlton-mens-loungepants-pack-of-1"] }, window.SO_OFFER || {}); // LIVE again 16 Oct (final offer: active-style S joins the bag offer, no stacking; excludedVariants = liquidation sock colours, golive_2026-10-16); eligibleHandles = the 71 bag-offer styles (golive_2026-10-13/golive_state.json)
  const SO_ICON = {
    truck: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>',
    tag: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg>',
    lock: '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>',
    shield: '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>',
    bag: '<svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg>'
  };
  function soEsc(s) { const d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function soRs(cents) { return '₹' + Math.round(cents / 100).toLocaleString('en-IN'); }
  function soSizeOf(it) {
    const o = (it.options_with_values || []).find((x) => /size/i.test(x.name));
    return o ? String(o.value).trim().toUpperCase() : '';
  }
  let _soRecs = { pid: null, list: [] };

  function soBagShell(drawer) {
    if (drawer._soBag) return;
    drawer._soBag = true;
    drawer.classList.add('so-bag');
    drawer.innerHTML = `
      <div class="so-bag-head">
        <h3>Your bag <span class="so-bag-count"></span></h3>
        <button type="button" class="so-drawer-close t4s-drawer__close" data-drawer-close aria-label="Close">&times;</button>
      </div>
      <div class="so-bag-perks"></div>
      <div class="so-bag-body">
        <div class="so-cart-items-list"></div>
        <div class="so-bag-recs"></div>
      </div>
      <div class="so-bag-foot"></div>`;
    drawer.addEventListener('click', (e) => {
      const step = e.target.closest('[data-bag-qty]');
      if (step) {
        e.preventDefault();
        drawer.classList.add('is-busy');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: step.getAttribute('data-key'), quantity: Number(step.getAttribute('data-bag-qty')) })
        }).then((r) => r.json().then((j) => { if (!r.ok) showToast((j.description || 'Could not update the bag.').replace(/<[^>]*>/g, '')); }))
          .catch(() => {}).then(() => updateCartUI()).then(() => drawer.classList.remove('is-busy'));
        return;
      }
      const add = e.target.closest('[data-bag-add]');
      if (add) {
        e.preventDefault();
        add.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: Number(add.getAttribute('data-bag-add')), quantity: 1 })
        }).then((r) => { if (!r.ok) showToast('Sorry, that size just sold out.'); })
          .catch(() => {}).then(() => updateCartUI());
      }
    });
  }

  function soOfferOn() {
    if (!SO_OFFER.enabled) return false;
    if (!SO_OFFER.onlyTag) return true;
    return (window.SO_CUSTOMER_TAGS || []).indexOf(SO_OFFER.onlyTag) > -1;
  }

  // Slab bar. Full-price lines count towards a slab and get its %, matching the Discount Bot
  // "Bag offer" (23 Oct: any style; on-sale lines, i.e. compare-at > price such as S 60% and clearance,
  // neither count nor get it). A line whose product JSON isn't cached yet doesn't count until
  // renderBag repaints. The saving shown is what Shopify actually applied (original_total_price - total_price).
  function soPerks(cart) {
    const before = cart.original_total_price != null ? cart.original_total_price : cart.total_price;
    const applied = Math.max(0, before - cart.total_price);
    let offer = '';
    if (soOfferOn() && before > 0) {
      let base = 0;
      cart.items.forEach((it) => {
        const unit = it.original_price != null ? it.original_price : it.price;
        const p = SO_PRODUCT_CACHE[it.handle];
        const v = p && p.variants.find((x) => x.id === it.variant_id);
        const fullPrice = !!v && !(v.compare_at_price > v.price);
        if (fullPrice && (SO_OFFER.excludedVariants || []).indexOf(it.variant_id) < 0) base += unit * it.quantity;
      });
      const tiers = SO_OFFER.tiers;
      let cur = -1;
      tiers.forEach((t, i) => { if (base >= t[0]) cur = i; });
      const next = tiers[cur + 1];
      const goal = next ? next[0] : tiers[tiers.length - 1][0];
      const prevGoal = cur >= 0 ? tiers[cur][0] : 0;
      const pctDone = next ? Math.max(4, Math.min(100, Math.round(((base - prevGoal) / (goal - prevGoal)) * 100))) : 100;
      let msg;
      if (cur < 0) {
        msg = base > 0
          ? `Add <b>${soRs(next[0] - base)}</b> more of full-price pieces to get <b>${next[1]}% off</b> them`
          : `Add <b>${soRs(next[0])}</b> of full-price pieces to get <b>${next[1]}% off</b> them`;
      } else if (next) {
        msg = `<b>${tiers[cur][1]}% off unlocked</b>${applied > 0 ? ` · you save ${soRs(applied)}` : ''}. Add <b>${soRs(next[0] - base)}</b> more for <b>${next[1]}% off</b>`;
      } else {
        msg = `<b>${tiers[cur][1]}% off unlocked</b> on your full-price pieces${applied > 0 ? ` · you save ${soRs(applied)}` : ''}`;
      }
      offer = `
        <div class="so-bag-offer${!next ? ' is-done' : ''}">
          <div class="so-bag-offer-txt">${SO_ICON.tag}<span>${msg}</span></div>
          <div class="so-bag-bar"><span style="width:${pctDone}%"></span></div>
          <div class="so-bag-tiers">${tiers.map((t, i) => `<span class="${i <= cur ? 'is-on' : ''}${i === cur + 1 ? ' is-next' : ''}">${soRs(t[0])}<b>${t[1]}%</b></span>`).join('')}</div>
          <div class="so-bag-offer-note">Applied automatically at checkout. Pieces already on sale (incl. size S) keep their sale price and don't count. <a href="/collections/offers#so-offers-guide">See the offer styles</a></div>
        </div>`;
    }
    return offer + (before > 0 ? `<div class="so-bag-free">${SO_ICON.truck}<span><b>Free delivery</b> on this order, anywhere in India</span></div>` : '');
  }

  async function soRenderRecs(cart, box) {
    if (!box) return;
    if (!cart.items.length) { box.innerHTML = ''; return; }
    const pid = cart.items[0].product_id;
    if (_soRecs.pid !== pid) {
      try {
        const r = await fetch('/recommendations/products.json?product_id=' + pid + '&limit=8');
        _soRecs = { pid, list: (await r.json()).products || [] };
      } catch (e) { _soRecs = { pid, list: [] }; }
    }
    const inBag = new Set(cart.items.map((i) => i.product_id));
    const wantSize = soSizeOf(cart.items[0]);
    const picks = _soRecs.list.filter((p) => p.available && !inBag.has(p.id)).slice(0, 3);
    if (!picks.length) { box.innerHTML = ''; return; }
    box.innerHTML = `<div class="so-bag-recs-h">Complete the look</div><div class="so-bag-recs-row">` + picks.map((p) => {
      const sizeIdx = (p.options || []).findIndex((o) => /size/i.test(o.name || o));
      let v = null;
      if (sizeIdx > -1 && wantSize) v = p.variants.find((x) => x.available && String(x['option' + (sizeIdx + 1)]).toUpperCase() === wantSize);
      if (!v && (p.variants.length === 1 || sizeIdx === -1)) v = p.variants.find((x) => x.available);
      const img = p.featured_image ? String(p.featured_image).split('?')[0] + '?width=240' : '';
      const was = v && v.compare_at_price > v.price ? `<s>${soRs(v.compare_at_price)}</s>` : '';
      return `<div class="so-bag-rec">
          <a href="${p.url}" class="so-bag-rec-img">${img ? `<img src="${img}" alt="" loading="lazy">` : ''}</a>
          <a href="${p.url}" class="so-bag-rec-t">${soEsc(p.title)}</a>
          <div class="so-bag-rec-p">${soRs(v ? v.price : p.price)} ${was}</div>
          ${v ? `<button type="button" class="so-bag-rec-add" data-bag-add="${v.id}">+ Add${sizeIdx > -1 && wantSize ? ' · ' + soEsc(wantSize) : ''}</button>`
              : `<a class="so-bag-rec-add" href="${p.url}">Choose size</a>`}
        </div>`;
    }).join('') + '</div>';
  }

  async function updateCartUI() {
    let cart;
    try { cart = await soFetchCart(); } catch (e) { return; }
    renderBag(cart);
    // MRP (compare-at) per line needs each product's JSON; paint first, then fill any missing ones in
    const missing = [...new Set(cart.items.map((i) => i.handle))].filter((h) => !SO_PRODUCT_CACHE[h]);
    if (missing.length) {
      await Promise.all(missing.map((h) => soGetProduct(h).catch(() => null)));
      if (_soCart === cart) renderBag(cart);
    }
  }

  function renderBag(cart) {
    const totalCount = cart.item_count;

    // Update badge counts
    document.querySelectorAll('[data-cart-count], .t4s-cart-count').forEach((el) => {
      el.textContent = totalCount;
      el.classList.toggle('t4s-op-0', totalCount === 0);
    });

    const drawer = document.getElementById('t4s-mini_cart');
    if (!drawer) return;
    soBagShell(drawer);

    let mrpTotal = 0;
    const rows = cart.items.map((it) => {
      const p = SO_PRODUCT_CACHE[it.handle];
      const v = p && p.variants.find((x) => x.id === it.variant_id);
      const unit = it.final_price != null ? it.final_price : it.price;
      const mrp = Math.max(unit, it.original_price || 0, (v && v.compare_at_price) || 0);
      mrpTotal += mrp * it.quantity;
      const off = mrp > unit ? Math.round((1 - unit / mrp) * 100) : 0;
      const max = v && v.inventory_management && v.inventory_policy === 'deny' && v.inventory_quantity > 0 ? v.inventory_quantity : 20;
      const img = it.image ? String(it.image).split('?')[0] + '?width=180' : '';
      return `
        <div class="so-bag-item">
          <a href="${it.url}" class="so-bag-img">${img ? `<img src="${img}" alt="" loading="lazy">` : ''}</a>
          <div class="so-bag-info">
            <a href="${it.url}" class="so-bag-title">${it.product_title}</a>
            ${it.variant_title ? `<div class="so-bag-var">${soEsc(it.variant_title)}</div>` : ''}
            <div class="so-bag-price"><b>${soRs(unit)}</b>${off ? ` <s>${soRs(mrp)}</s> <span class="so-bag-off">${off}% OFF</span>` : ''}</div>
            <div class="so-bag-row">
              <div class="so-bag-qty">
                <button type="button" data-bag-qty="${it.quantity - 1}" data-key="${it.key}" aria-label="Decrease quantity">&minus;</button>
                <span>${it.quantity}</span>
                <button type="button" data-bag-qty="${it.quantity + 1}" data-key="${it.key}" aria-label="Increase quantity"${it.quantity >= max ? ' disabled' : ''}>+</button>
              </div>
              <button type="button" class="so-bag-rm" data-cart-remove-key="${it.key}">Remove</button>
            </div>
          </div>
        </div>`;
    });

    drawer.querySelector('.so-bag-count').textContent = totalCount ? `(${totalCount} ${totalCount === 1 ? 'item' : 'items'})` : '';
    drawer.querySelector('.so-bag-perks').innerHTML = soPerks(cart);
    const list = drawer.querySelector('.so-cart-items-list');
    const foot = drawer.querySelector('.so-bag-foot');
    if (!cart.items.length) {
      list.innerHTML = `<div class="so-bag-empty">${SO_ICON.bag}<p>Your bag is empty</p><span>Genuine PUMA, FCUK and French Connection, delivered free across India.</span><a href="/collections/all" class="so-bag-cta">Start shopping</a></div>`;
      foot.innerHTML = '';
      foot.style.display = 'none';
    } else {
      list.innerHTML = rows.join('');
      const saved = mrpTotal - cart.total_price;
      foot.style.display = '';
      foot.innerHTML = `
        ${saved > 0 ? `<div class="so-bag-save">You're saving <b>${soRs(saved)}</b> on this order</div>` : ''}
        <div class="so-bag-sub"><span>Subtotal <small>(incl. of all taxes)</small></span><span class="so-cart-subtotal">${soRs(cart.total_price)}</span></div>
        <button type="button" id="so-checkout-btn" class="so-bag-checkout">Checkout · ${soRs(cart.total_price)}</button>
        <div class="so-bag-trust"><span>${SO_ICON.lock} Secure checkout</span><span>${SO_ICON.shield} 100% genuine brands</span></div>`;
    }
    soRenderRecs(cart, drawer.querySelector('.so-bag-recs'));
  }

  // keep the real cart badge/drawer in sync on every page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { updateCartUI(); });
  } else {
    updateCartUI();
  }
  // warm the product JSON so "add" is a single request: PDP on load, cards when their add button is touched/hovered
  (function () {
    const pdp = () => { const el = document.getElementById('so-pdp-data'); if (!el) return; try { soPrefetch(JSON.parse(el.textContent).handle); } catch (e) {} };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pdp); else pdp();
    const warm = (e) => {
      const b = e.target.closest && e.target.closest('.so-card-atc-btn, [data-action-addtobag], [data-action-quickshop], [data-action-quickview]');
      if (!b) return;
      const c = b.closest('[data-so-card], [data-so-rail-card]');
      soPrefetch(b.getAttribute('data-handle') || (c && (c.getAttribute('data-so-card') || c.getAttribute('data-so-rail-card'))));
    };
    document.addEventListener('pointerdown', warm, true);
    document.addEventListener('mouseover', warm, { passive: true });
  })();

  // --- 3. Drawer System (Menu, Search, Mini-Cart, Filter) ---
  function openDrawer(selector) {
    const drawer = document.querySelector(selector);
    if (!drawer) return;
    if (drawer._closeTimer) {
      clearTimeout(drawer._closeTimer);
      drawer._closeTimer = null;
    }
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.remove('t4s-dn');
    drawer.classList.add('is--opened');
    drawer.style.transform = 'translateX(0)';
    drawer.style.visibility = 'visible';
    
    let overlay = document.getElementById('so-drawer-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'so-drawer-overlay';
      document.body.appendChild(overlay);
      overlay.addEventListener('click', closeAllDrawers);
    }
    overlay.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.55);z-index:10000;display:block;backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px);transition:opacity .15s;';
    document.body.style.overflow = 'hidden';
  }

  function closeAllDrawers() {
    document.querySelectorAll('.t4s-drawer').forEach((d) => {
      d.setAttribute('aria-hidden', 'true');
      d.classList.remove('is--opened');
      if (d._closeTimer) {
        clearTimeout(d._closeTimer);
        d._closeTimer = null;
      }
      if (d.classList.contains('t4s-drawer__left')) {
        d.style.transform = 'translateX(-100%)';
      } else {
        d.style.transform = 'translateX(100%)';
      }
      d._closeTimer = setTimeout(() => {
        if (!d.classList.contains('is--opened')) d.style.visibility = 'hidden';
      }, 320);
    });
    const overlay = document.getElementById('so-drawer-overlay');
    if (overlay) overlay.style.display = 'none';
    document.body.style.overflow = '';
    document.querySelectorAll('.so-bag-added').forEach((el) => el.remove());   // next open shows just the bag
  }

  // --- 4. Predictive Search Drawer ---
  let searchProducts = null;
  function initSearch() {
    const input = document.getElementById('so-search-input');
    const results = document.getElementById('so-search-results');
    if (!input || !results) return;

    async function loadIndex() {
      if (!searchProducts) {
        try {
          const res = await fetch(window.SO_SEARCH_INDEX || '/search_index.json');
          searchProducts = await res.json();
        } catch (e) {
          searchProducts = [];
        }
      }
    }

    // 12 Oct: live Shopify predictive search (title, vendor, type, tags, SKU, barcode) so style numbers like
    // 67458902 are found and prices are live; the static index (name/brand/handle) only tops up the list.
    const inr = (v) => '₹' + Math.round(parseFloat(v)).toLocaleString('en-IN');
    let seq = 0, timer = null;
    function render(raw, hits) {
      if (hits.length === 0) {
        results.innerHTML = `<div style="padding: 20px; color: #666; text-align: center;">No styles found matching "${raw.replace(/[<>&"]/g, '')}".</div>`;
        return;
      }
      results.innerHTML = `
          <div style="display: flex; flex-direction: column; gap: 10px; padding: 10px 0;">
            ${hits.map((h) => `
              <a href="${h.url}" style="display: flex; gap: 12px; align-items: center; padding: 8px; border-radius: 6px; text-decoration: none; color: inherit; transition: background .15s;" onmouseover="this.style.background='#f7f6f4'" onmouseout="this.style.background='transparent'">
                <img src="${h.image}" alt="${h.title}" style="width: 50px; height: 66px; object-fit: cover; border-radius: 4px;">
                <div>
                  <div style="font-size: 11px; text-transform: uppercase; font-weight: 700; color: #888;">${h.brand}</div>
                  <div style="font-size: 13.5px; font-weight: 600; color: #111;">${h.title}</div>
                  <div style="font-size: 13px; font-weight: 700; color: #111;">${h.price}</div>
                </div>
              </a>
            `).join('')}
            <a href="/search?type=product&q=${encodeURIComponent(raw)}" style="display: block; text-align: center; padding: 12px; background: #111; color: #fff; border-radius: 6px; font-weight: 600; font-size: 13px; text-decoration: none; margin-top: 10px;">View all results</a>
          </div>
        `;
    }
    async function runSearch(raw) {
      const q = raw.toLowerCase();
      const my = ++seq;
      let hits = [];
      try {
        const r = await fetch('/search/suggest.json?q=' + encodeURIComponent(raw) +
          '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last' +
          '&resources[options][fields]=title,product_type,vendor,tag,variants.sku,variants.barcode,variants.title');
        const d = await r.json();
        hits = ((d.resources && d.resources.results && d.resources.results.products) || []).map((p) => ({
          url: '/products/' + p.handle, title: p.title, brand: p.vendor || '',
          image: (p.image || (p.featured_image && p.featured_image.url) || '') + ((p.image || '').includes('?') ? '&' : '?') + 'width=160',
          price: inr(p.price)
        }));
      } catch (err) { hits = []; }
      if (hits.length < 8) {
        await loadIndex();
        const seen = new Set(hits.map((h) => h.url));
        searchProducts.filter((p) => (p.title + ' ' + p.brand + ' ' + p.handle).toLowerCase().includes(q))
          .forEach((p) => { if (hits.length < 8 && !seen.has(p.url)) { seen.add(p.url); hits.push(p); } });
      }
      if (my === seq) render(raw, hits);
    }
    input.addEventListener('input', (e) => {
      const raw = e.target.value.trim();
      clearTimeout(timer);
      if (raw.length < 2) {
        seq++;
        results.innerHTML = '<div style="padding: 20px; color: #888; text-align: center;">Type at least 2 letters to search...</div>';
        return;
      }
      timer = setTimeout(() => runSearch(raw), 200);
    });
    input.addEventListener('keydown', (e) => {
      const raw = input.value.trim();
      if (e.key === 'Enter' && raw) { e.preventDefault(); location.href = '/search?type=product&q=' + encodeURIComponent(raw); }
    });
  }

  // --- 5. Quick View Modal ---
  function openQuickView(productHandle, targetSize = null) {
    const card = document.querySelector(`[data-so-card="${productHandle}"]`) ||
                 document.querySelector(`[data-so-rail-card="${productHandle}"]`);
    if (!card) return;

    const titleEl = card.querySelector('[data-so-pname]');
    const title = titleEl ? titleEl.textContent.trim() : 'Product';
    const priceEl = card.querySelector('.t4s-product-price');
    const priceHtml = priceEl ? priceEl.innerHTML : '';
    const imgEl = card.querySelector('.t4s-product-main-img');
    const imgSrc = imgEl ? (imgEl.getAttribute('data-src') || imgEl.src) : '';
    const brand = title.split(' ')[0] || 'Underlinen';

    let qvModal = document.getElementById('so-quick-view-modal');
    if (!qvModal) {
      qvModal = document.createElement('div');
      qvModal.id = 'so-quick-view-modal';
      qvModal.className = 'so-modal-overlay';
      document.body.appendChild(qvModal);
    }

    // Extract sizes from card
    const sizeSpans = card.querySelectorAll('.t4s-product-sizes span span');
    const sizes = Array.from(sizeSpans).map((s) => s.textContent.trim());

    // Extract colors from card swatches
    const colorItems = card.querySelectorAll('.t4s-product-colors .t4s-pr-color__value');

    qvModal.innerHTML = `
      <div class="so-modal-box" style="max-width: 680px;">
        <button class="so-modal-close" data-modal-close>&times;</button>
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 24px; align-items: start;">
          <div>
            <img src="${imgSrc}" id="so-qv-main-img" alt="${title}" style="width: 100%; border-radius: 8px; object-fit: cover; aspect-ratio: 3/4;">
          </div>
          <div>
            <div style="font-size: 11px; text-transform: uppercase; font-weight: 700; color: #1c3d32; letter-spacing: .1em;">${brand}</div>
            <h3 style="font-size: 18px; font-weight: 700; color: #111; margin: 4px 0 10px;">${title}</h3>
            <div class="t4s-product-price" style="margin-bottom: 16px;">${priceHtml}</div>
            
            <div style="margin-bottom: 16px;" id="so-qv-size-section">
              <div style="font-size: 12px; font-weight: 700; text-transform: uppercase; margin-bottom: 6px;">Size:</div>
              <div style="display: flex; flex-wrap: wrap; gap: 8px;">
                ${sizes.map((s, i) => `
                  <button type="button" class="so-qv-size-btn ${i === 0 ? 'so-active-size' : ''}" data-size="${s}" style="padding: 6px 14px; border: 1px solid ${i === 0 ? '#111' : '#ccc'}; background: ${i === 0 ? '#111' : '#fff'}; color: ${i === 0 ? '#fff' : '#111'}; border-radius: 4px; font-size: 12px; font-weight: 600; cursor: pointer;">${s}</button>
                `).join('')}
              </div>
            </div>

            <div style="display: flex; gap: 12px; align-items: center; margin-bottom: 20px;">
              <div style="display: flex; border: 1px solid #ccc; border-radius: 4px; overflow: hidden;">
                <button type="button" id="so-qv-minus" style="padding: 8px 12px; background: #f7f6f4; border: none; cursor: pointer;">-</button>
                <input type="text" id="so-qv-qty" value="1" readonly style="width: 40px; text-align: center; border: none; font-weight: 600;">
                <button type="button" id="so-qv-plus" style="padding: 8px 12px; background: #f7f6f4; border: none; cursor: pointer;">+</button>
              </div>
              <button type="button" id="so-qv-atc-btn" style="flex: 1; padding: 12px 20px; background: #111; color: #fff; border: none; border-radius: 4px; font-weight: 700; font-size: 13.5px; cursor: pointer;">Add to Cart</button>
            </div>

            <a href="/products/${productHandle}" style="display: block; font-size: 13px; color: #1c3d32; font-weight: 600; text-decoration: underline;">View full details &rarr;</a>
          </div>
        </div>
      </div>
    `;

    qvModal.classList.add('so-active');

    // Handle modal buttons
    let selectedSize = sizes[0] || 'Free Size';
    qvModal.querySelectorAll('.so-qv-size-btn').forEach((b) => {
      b.addEventListener('click', () => {
        qvModal.querySelectorAll('.so-qv-size-btn').forEach((btn) => {
          btn.style.background = '#fff';
          btn.style.color = '#111';
          btn.style.borderColor = '#ccc';
        });
        b.style.background = '#111';
        b.style.color = '#fff';
        b.style.borderColor = '#111';
        selectedSize = b.getAttribute('data-size');
      });
    });

    let qty = 1;
    const qtyInput = qvModal.querySelector('#so-qv-qty');
    qvModal.querySelector('#so-qv-minus').addEventListener('click', () => {
      if (qty > 1) { qty--; qtyInput.value = qty; }
    });
    qvModal.querySelector('#so-qv-plus').addEventListener('click', () => {
      qty++; qtyInput.value = qty;
    });

    qvModal.querySelector('#so-qv-atc-btn').addEventListener('click', () => {
      addToCart({
        handle: productHandle,
        title: title,
        price: card.querySelector('.t4s-price__sale, .t4s-product-price')?.textContent.trim().split('–')[0].trim() || '₹ 500.00',
        image: imgSrc,
        size: selectedSize,
        qty: qty
      });
      qvModal.classList.remove('so-active');
    });

    qvModal.querySelector('[data-modal-close]').addEventListener('click', () => {
      qvModal.classList.remove('so-active');
    });

    qvModal.addEventListener('click', (e) => {
      if (e.target === qvModal) qvModal.classList.remove('so-active');
    });

    if (targetSize) {
      const sizeSec = qvModal.querySelector('#so-qv-size-section');
      if (sizeSec) sizeSec.scrollIntoView({ behavior: 'smooth' });
    }
  }

  // --- 6. Slideshow System ---
  function initSlideshow() {
    if (document.querySelector('[data-so-hero]')) return;   // round 2 hero: so-v2.js
    const slides = document.querySelectorAll('[data-so-slide]');
    if (!slides.length) return;

    let current = 0;
    const total = slides.length;
    let timer = null;

    function show(index) {
      current = (index + total) % total;
      slides.forEach((sl, i) => {
        sl.style.display = i === current ? 'block' : 'none';
      });
      document.querySelectorAll('.so-slide-dot').forEach((d, i) => {
        d.classList.toggle('so-dot-active', i === current);
      });
    }

    function startTimer() {
      stopTimer();
      timer = setInterval(() => show(current + 1), 5000);
    }

    function stopTimer() {
      if (timer) clearInterval(timer);
    }

    const sliderWrap = document.querySelector('.t4s-sec-slideshow, .t4s-slideshow');
    if (sliderWrap) {
      sliderWrap.addEventListener('mouseenter', stopTimer);
      sliderWrap.addEventListener('mouseleave', startTimer);
    }

    document.querySelectorAll('[data-slide-prev]').forEach((btn) => {
      btn.addEventListener('click', () => { show(current - 1); startTimer(); });
    });
    document.querySelectorAll('[data-slide-next]').forEach((btn) => {
      btn.addEventListener('click', () => { show(current + 1); startTimer(); });
    });
    document.querySelectorAll('.so-slide-dot').forEach((dot, idx) => {
      dot.addEventListener('click', () => { show(idx); startTimer(); });
    });

    show(0);
    startTimer();
  }

  // --- 7. Collection Grid, Pagination & Filters ---
  function initCollectionGrid() {
    const grid = document.querySelector('[data-so-grid]');
    if (!grid) return;

    const cards = Array.from(grid.querySelectorAll('[data-so-card]'));
    const countEl = document.getElementById('so-product-count');
    const loadMoreBtn = document.getElementById('so-load-more');
    let visibleCount = 24;

    function renderGrid() {
      const activeFilters = getActiveFilters();
      // so-oos = no size in stock on Shopify right now (set live by so-live-prices.js)
      let matched = cards.filter((card) => !card.classList.contains('so-oos') && matchesFilter(card, activeFilters));

      // Sort
      const sortVal = document.getElementById('so-sort-select')?.value || 'featured';
      if (sortVal === 'low') {
        matched.sort((a, b) => parseFloat(a.dataset.price || 0) - parseFloat(b.dataset.price || 0));
      } else if (sortVal === 'high') {
        matched.sort((a, b) => parseFloat(b.dataset.price || 0) - parseFloat(a.dataset.price || 0));
      } else if (sortVal === 'newest') {
        matched.sort((a, b) => parseInt(b.dataset.date || 0) - parseInt(a.dataset.date || 0));
      }

      // Hide all first
      cards.forEach((c) => (c.style.display = 'none'));

      // Show matched up to visibleCount
      const toShow = matched.slice(0, visibleCount);
      toShow.forEach((c) => (c.style.display = ''));

      // Re-append in sorted order
      matched.forEach((c) => grid.appendChild(c));

      // Update count
      if (countEl) {
        countEl.textContent = `${matched.length} Products`;
      }

      // Load more button visibility
      if (loadMoreBtn) {
        loadMoreBtn.style.display = visibleCount >= matched.length ? 'none' : 'inline-block';
      }
    }

    function getActiveFilters() {
      const filters = {};
      document.querySelectorAll('.so-filter-checkbox:checked').forEach((cb) => {
        const group = cb.dataset.filterGroup;
        const val = cb.value;
        if (!filters[group]) filters[group] = [];
        filters[group].push(val);
      });
      return filters;
    }

    function matchesFilter(card, filters) {
      for (const group in filters) {
        const allowed = filters[group];
        if (!allowed || !allowed.length) continue;
        const cardVal = card.dataset[group];
        if (group === 'size' || group === 'color') {
          // Multivalue comma separated
          const values = (cardVal || '').split(',').map((s) => s.trim().toLowerCase());
          if (!allowed.some((a) => values.includes(a.toLowerCase()))) return false;
        } else if (group === 'price') {
          const p = parseFloat(card.dataset.price || 0);
          const ok = allowed.some((range) => {
            if (range === 'under500') return p < 500;
            if (range === '500-999') return p >= 500 && p <= 999;
            if (range === '1000-1499') return p >= 1000 && p <= 1499;
            if (range === '1500plus') return p >= 1500;
            return false;
          });
          if (!ok) return false;
        } else {
          if (!allowed.includes(cardVal)) return false;
        }
      }
      return true;
    }

    // Grid layout toggles
    document.querySelectorAll('[data-grid-cols]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const cols = btn.getAttribute('data-grid-cols');
        Array.from(grid.classList).forEach((c) => { if (/^t4s-row-cols-(md|lg)-\d$/.test(c)) grid.classList.remove(c); });
        grid.classList.add(`t4s-row-cols-md-${cols}`, `t4s-row-cols-lg-${cols}`);
        document.querySelectorAll('[data-grid-cols]').forEach((b) => b.classList.remove('is--active'));
        btn.classList.add('is--active');
      });
    });

    // Sort select
    document.getElementById('so-sort-select')?.addEventListener('change', () => {
      visibleCount = 24;
      renderGrid();
    });

    // Filter changes
    document.querySelectorAll('.so-filter-checkbox').forEach((cb) => {
      cb.addEventListener('change', () => {
        visibleCount = 24;
        renderGrid();
      });
    });

    // Clear filters
    document.getElementById('so-clear-filters')?.addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelectorAll('.so-filter-checkbox:checked').forEach((cb) => (cb.checked = false));
      visibleCount = 24;
      renderGrid();
    });

    // Load more click
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', (e) => {
        e.preventDefault();
        visibleCount += 24;
        renderGrid();
      });
    }

    renderGrid();
  }

  // --- 8. PDP Gallery, Swatches & Tabs ---
  function initPDP() {
    if (!document.querySelector('[data-so-pdp]')) initPDPv1();   // round 2 product page: so-v2.js
    initModals();
  }

  function initPDPv1() {
    // Thumbnail gallery click
    const mainImg = document.getElementById('so-pdp-main-img');
    document.querySelectorAll('.t4s-product__thumb-item, [data-thumb-img]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const fullSrc = thumb.getAttribute('data-thumb-full') || thumb.querySelector('img')?.src;
        if (mainImg && fullSrc) {
          mainImg.src = fullSrc;
          document.querySelectorAll('.t4s-product__thumb-item').forEach((t) => t.classList.remove('is--active'));
          thumb.classList.add('is--active');
        }
      });
    });

    // PDP Swatches
    document.querySelectorAll('[data-so-swatch]').forEach((swatch) => {
      swatch.addEventListener('click', () => {
        const col = swatch.getAttribute('data-so-swatch');
        const img = swatch.getAttribute('data-swatch-img');
        if (mainImg && img) mainImg.src = img;
        document.querySelectorAll('[data-so-swatch]').forEach((s) => s.classList.remove('is--selected'));
        swatch.classList.add('is--selected');
        const colLabel = document.getElementById('so-selected-color');
        if (colLabel) colLabel.textContent = col.replace(/\bPuma\b/g, 'PUMA').replace(/\bFcuk\b/g, 'FCUK');
      });
    });

    // PDP Size Buttons
    document.querySelectorAll('.so-pdp-size-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        document.querySelectorAll('.so-pdp-size-btn').forEach((b) => b.classList.remove('is--selected'));
        btn.classList.add('is--selected');
        const sizeLabel = document.getElementById('so-selected-size');
        if (sizeLabel) sizeLabel.textContent = btn.getAttribute('data-size');
      });
    });

    // PDP Quantity Buttons
    let pdpQty = 1;
    const pdpQtyInput = document.getElementById('so-pdp-qty');
    document.getElementById('so-pdp-minus')?.addEventListener('click', () => {
      if (pdpQty > 1) { pdpQty--; if (pdpQtyInput) pdpQtyInput.value = pdpQty; }
    });
    document.getElementById('so-pdp-plus')?.addEventListener('click', () => {
      pdpQty++; if (pdpQtyInput) pdpQtyInput.value = pdpQty;
    });

    // PDP Add to Cart
    document.getElementById('so-pdp-atc')?.addEventListener('click', () => {
      const title = document.querySelector('h1.t4s-product__title')?.textContent.trim() || 'Product';
      const handle = window.location.pathname.split('/').filter(Boolean).pop();
      const price = document.querySelector('.t4s-product-price')?.textContent.trim().split('–')[0].trim() || '₹ 500.00';
      const color = document.getElementById('so-selected-color')?.textContent.trim() || '';
      const size = document.getElementById('so-selected-size')?.textContent.trim() || 'Free Size';
      const img = mainImg ? mainImg.src : '';
      addToCart({ handle, title, price, color, size, image: img, qty: pdpQty });
    });

    // PDP Tabs
    document.querySelectorAll('[data-t4s-tab-item]').forEach((tabLink) => {
      tabLink.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = tabLink.getAttribute('href');
        if (!targetId || !targetId.startsWith('#')) return;
        document.querySelectorAll('[data-t4s-tab-item]').forEach((t) => t.classList.remove('t4s-active'));
        document.querySelectorAll('.t4s-tab-content').forEach((c) => (c.style.display = 'none'));
        tabLink.classList.add('t4s-active');
        const targetContent = document.querySelector(targetId);
        if (targetContent) targetContent.style.display = 'block';
      });
    });
  }

  function initModals() {
    // Size Guide Modal Open/Close
    document.querySelectorAll('[data-open-size-guide]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const modal = document.getElementById('so-size-guide-modal');
        if (modal) modal.classList.add('so-active');
      });
    });

    // Ask a Question Modal Open/Close
    document.querySelectorAll('[data-open-ask-modal]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const modal = document.getElementById('so-ask-modal');
        if (modal) modal.classList.add('so-active');
      });
    });

    // Close Modals
    document.querySelectorAll('[data-modal-close]').forEach((btn) => {
      btn.addEventListener('click', () => {
        document.querySelectorAll('.so-modal-overlay').forEach((m) => m.classList.remove('so-active'));
      });
    });
    document.querySelectorAll('.so-modal-overlay').forEach((m) => {
      m.addEventListener('click', (e) => {
        if (e.target === m) m.classList.remove('so-active');
      });
    });
  }

  // --- 9. Global Delegations ---
  function initGlobalDelegations() {
    // Quick view / Quick shop clicks
    document.addEventListener('click', (e) => {
      const qvBtn = e.target.closest('[data-action-quickview]');
      if (qvBtn) {
        e.preventDefault();
        const handle = qvBtn.closest('[data-so-card], [data-so-rail-card]')?.getAttribute('data-so-card') ||
                       qvBtn.closest('[data-so-card], [data-so-rail-card]')?.getAttribute('data-so-rail-card');
        if (handle) openQuickView(handle);
        return;
      }

      const qsBtn = e.target.closest('[data-action-quickshop]');
      if (qsBtn) {
        e.preventDefault();
        const handle = qsBtn.closest('[data-so-card], [data-so-rail-card]')?.getAttribute('data-so-card') ||
                       qsBtn.closest('[data-so-card], [data-so-rail-card]')?.getAttribute('data-so-rail-card');
        if (handle) openQuickView(handle, 'size');
        return;
      }

      // Wishlist heart
      const wishBtn = e.target.closest('[data-replace-wishlist], [data-link-wishlist], .t4s-toolbart-wish');
      if (wishBtn) {
        e.preventDefault();
        showToast('Wishlist and account work on the live store.');
        return;
      }

      // Account links navigate to Shopify's real account pages.

      // Checkout button -> Shopify checkout
      const checkoutBtn = e.target.closest('#so-checkout-btn, [data-checkout-btn]');
      if (checkoutBtn) {
        e.preventDefault();
        if (checkoutBtn.closest('.t4s-mini_cart') && !( _soCart && _soCart.item_count > 0)) {
          showToast('Your cart is empty.');
          return;
        }
        window.location.href = '/checkout';
      }

      // Drawer trigger
      const drawerTrigger = e.target.closest('[data-drawer-options]');
      if (drawerTrigger) {
        e.preventDefault();
        try {
          const opts = JSON.parse(drawerTrigger.getAttribute('data-drawer-options'));
          if (opts.id) openDrawer(opts.id);
        } catch (err) {}
        return;
      }

      // Close drawer button
      const closeBtn = e.target.closest('[data-drawer-close], .t4s-drawer__close, .t4s-drawer-menu__close');
      if (closeBtn) {
        e.preventDefault();
        closeAllDrawers();
        return;
      }

      // Card Swatch click
      const cardColor = e.target.closest('.t4s-product-colors .t4s-pr-color__value');
      if (cardColor) {
        const card = cardColor.closest('[data-so-card], [data-so-rail-card]');
        const img2 = cardColor.getAttribute('data-img');
        const mainImg = card?.querySelector('.t4s-product-main-img');
        if (mainImg && img2) {
          mainImg.src = img2;
        }
      }

      // Cart item remove -> Shopify cart change API
      const removeBtn = e.target.closest('[data-cart-remove-key]');
      if (removeBtn) {
        e.preventDefault();
        const key = removeBtn.getAttribute('data-cart-remove-key');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).then(() => updateCartUI()).catch(() => {});
      }
    });

    // Mobile drawer accordion toggles (event delegation on document)
    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('.so-mb-toggle, .so-mb-accordion-toggle');
      if (toggle) {
        e.preventDefault();
        e.stopPropagation();
        const parent = toggle.closest('.so-has-sub, .t4s-menu-item-has-children');
        if (parent) {
          const isOpen = parent.classList.toggle('is--opend');
          toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          const sub = parent.querySelector('.so-mb-sub, .t4s-sub-menu');
          if (sub) {
            sub.style.display = isOpen ? 'block' : 'none';
          }
        }
      }
    });

    // Close drawers on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAllDrawers();
    });

    // FAQ Accordion click
    document.querySelectorAll('.so-faq-q').forEach((btn) => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.so-faq-item');
        if (item) item.classList.toggle('so-open');
      });
    });

    // Back to top
    const btt = document.getElementById('t4s-backToTop');
    if (btt) {
      window.addEventListener('scroll', () => {
        btt.classList.toggle('is--show', window.scrollY > 300);
      });
      btt.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  }

  // --- 10. Shared with so-v2.js (round 2 hero, product page) ---
  window.SO = { addToCart, showToast, openDrawer };

  // --- 11. Initialization on DOMContentLoaded ---
  document.addEventListener('DOMContentLoaded', () => {
    updateCartUI();
    initSearch();
    initSlideshow();
    initCollectionGrid();
    initPDP();
    initGlobalDelegations();
  });
})();

// One-row product carousels: prev/next arrows (Claude, 25 Sep)
(function () {
  document.querySelectorAll('.so-rail').forEach(function (rail) {
    var wrap = document.createElement('div');
    wrap.className = 'so-rail-wrap';
    rail.parentNode.insertBefore(wrap, rail);
    wrap.appendChild(rail);
    function mk(cls, label, sym) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'so-rail-arrow ' + cls; b.setAttribute('aria-label', label); b.textContent = sym;
      wrap.appendChild(b); return b;
    }
    var prev = mk('is-prev', 'Previous products', '‹');
    var next = mk('is-next', 'Next products', '›');
    function sync() {
      prev.disabled = rail.scrollLeft <= 4;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
    }
    prev.addEventListener('click', function () { rail.scrollBy({ left: -rail.clientWidth, behavior: 'smooth' }); });
    next.addEventListener('click', function () { rail.scrollBy({ left: rail.clientWidth, behavior: 'smooth' }); });
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });
})();
/* === SO-MYNTRA-RATINGS (Claude, 7 Oct 2026): gold ratings + bottom reviews section, synced from Myntra === */
(function(){
  if (window.__soRatingsInit) return; window.__soRatingsInit = true;
  var URL = window.SO_RATINGS_URL || '/assets/ratings.json';
  var S = '★★★★★';
  function stars(avg, cls){
    var pct = Math.max(0, Math.min(100, ((avg||0)/5)*100)).toFixed(1);
    return '<span class="so-rating__stars '+(cls||'')+'"><i class="so-rating__base">'+S+'</i>'
         + '<i class="so-rating__fill" style="width:'+pct+'%">'+S+'</i></span>';
  }
  function fmt(n){ return n>=1000 ? (n/1000).toFixed(1).replace(/\.0$/,'')+'k' : ''+n; }
  function esc(s){ var d=document.createElement('div'); d.textContent = s==null?'':s; return d.innerHTML; }
  function handleOf(el){ var a=el.querySelector('a[href*="/products/"]'); if(!a) return null;
    var m=a.getAttribute('href').match(/\/products\/([a-z0-9\-_]+)/i); return m?m[1]:null; }

  function pdpRow(r){
    var d=document.createElement('div'); d.className='so-rating so-pdp-rating';
    var cnt=fmt(r.ratings)+' ratings'+(r.reviews?' · '+fmt(r.reviews)+' reviews':'');
    d.innerHTML = stars(r.avg) + '<span class="so-rating__num">'+r.avg.toFixed(1)+'</span>'
      + '<a class="so-rating__count" href="#so-reviews">'+cnt+'</a>';
    return d;
  }
  function cardRow(r){
    var d=document.createElement('div'); d.className='so-rating so-card-rating';
    d.innerHTML = stars(r.avg) + '<span class="so-rating__num">'+r.avg.toFixed(1)+'</span>'
      + '<span class="so-rating__count">('+fmt(r.ratings)+')</span>';
    return d;
  }
  function distBars(r){
    if(!r.dist) return '';
    var tot=0,i; for(i=5;i>=1;i--) tot+=r.dist[i]||0; if(!tot) return '';
    var h='<div class="so-rv-dist">';
    for(i=5;i>=1;i--){ var c=r.dist[i]||0, p=(c/tot*100).toFixed(0);
      h+='<div class="so-rv-bar"><span class="lbl">'+i+'★</span><span class="track">'
        +'<span class="fill" style="width:'+p+'%"></span></span><span>'+fmt(c)+'</span></div>'; }
    return h+'</div>';
  }
  function reviewsSection(r){
    var sec=document.createElement('section'); sec.id='so-reviews';
    var cards=(r.top||[]).map(function(rv){
      var imgs=(rv.imgs||[]).map(function(u){return '<img loading="lazy" src="'+u+'" data-full="'+u+'">';}).join('');
      return '<div class="so-rv-card">'+stars(rv.r||r.avg)
        +'<div class="so-rv-text">'+esc(rv.t)+'</div>'
        +(imgs?'<div class="so-rv-imgs">'+imgs+'</div>':'')
        +'<div class="so-rv-name">'+esc(rv.n)+'</div></div>';
    }).join('');
    sec.innerHTML =
      '<div class="so-rv-head"><h2>Ratings &amp; Reviews</h2><span class="so-rv-src">Synced from Myntra</span></div>'
      + '<div class="so-rv-summary"><div style="text-align:center"><div class="so-rv-big">'+r.avg.toFixed(1)+'</div>'
      + '<div class="so-rv-sumstars">'+stars(r.avg)+'</div>'
      + '<div class="so-rv-sumcount">'+fmt(r.ratings)+' ratings · '+fmt(r.reviews)+' reviews</div></div>'
      + distBars(r) + '</div>'
      + (cards ? '<div class="so-rv-grid">'+cards+'</div>' : '');
    return sec;
  }
  function apply(data){
    var pdp=document.querySelector('[data-handle]');
    var h1=document.querySelector('h1.so-pdp-title, h1.t4s-product__title');
    if(pdp && h1){
      var r=data[pdp.getAttribute('data-handle')];
      if(r){
        if(!document.querySelector('.so-pdp-rating')) h1.insertAdjacentElement('afterend', pdpRow(r));
        if(r.top && r.top.length && !document.getElementById('so-reviews')){
          var footer=document.querySelector('footer');
          var sec=reviewsSection(r);
          if(footer) footer.parentNode.insertBefore(sec, footer); else document.body.appendChild(sec);
        }
      }
    }
    document.querySelectorAll('[data-so-card],[data-so-rail-card]').forEach(function(card){
      if(card.querySelector('.so-card-rating')) return;
      var h=handleOf(card); if(!h) return; var r=data[h]; if(!r) return;
      var t=card.querySelector('.t4s-product-title, .t4s-product__title');
      var a=t||card.querySelector('.t4s-product-price, .so-pricerow');
      if(a) a.insertAdjacentElement(t?'afterend':'beforebegin', cardRow(r));
    });
    window.__soRatings=data;
  }
  // one-time global handlers: scroll link + image lightbox
  document.addEventListener('click', function(e){
    var a=e.target.closest && e.target.closest('a.so-rating__count[href="#so-reviews"]');
    if(a){ var s=document.getElementById('so-reviews'); if(s){ e.preventDefault(); s.scrollIntoView({behavior:'smooth'}); } return; }
    var im=e.target.closest && e.target.closest('.so-rv-imgs img');
    if(im){
      var lb=document.getElementById('so-lb');
      if(!lb){ lb=document.createElement('div'); lb.id='so-lb'; lb.className='so-lb'; lb.innerHTML='<img>';
        lb.addEventListener('click', function(){ lb.classList.remove('on'); }); document.body.appendChild(lb); }
      lb.querySelector('img').src=im.getAttribute('data-full'); lb.classList.add('on');
    }
  });
  function init(){ fetch(URL).then(function(x){return x.json();}).then(apply).catch(function(){}); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.__soApplyRatings=function(){ if(window.__soRatings) apply(window.__soRatings); };
})();
